import Image from '@/modules/common/components/Image';
import { cn } from '@/modules/common/lib/utils';

import { useDesignerQuery } from '../../gql/__generated/designer.generated';

type DesignerFlagProps = {
  id: string;
  isRounded?: boolean;
};

export default function DesignerFlag({ id, isRounded }: DesignerFlagProps) {
  const { data, isLoading } = useDesignerQuery({
    id,
  });

  const designer = data?.designer;

  if (isLoading || !designer) {
    return null;
  }

  return (
    <div
      className={cn('absolute z-1 h-16', {
        'rounded-l-lg': isRounded,
      })}
    >
      <div
        className={cn('relative h-16 w-[231px] overflow-hidden', {
          'rounded-tl-[1.25rem]': isRounded,
        })}
        style={{
          background: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(7px)',
          clipPath: 'polygon(0% 0%, 90.9% 0%, 85.4% 50%, 90.9% 100%, 0% 100%)',
        }}
      >
        <div className="relative z-10 flex h-16 items-center gap-2 pl-2">
          <Image
            src={designer.avatar?.url || ''}
            alt={designer.name || 'Designer Avatar'}
            className="block h-[48px] w-[48px] overflow-hidden rounded-full object-cover"
          />

          <div className="flex w-[134px] flex-col justify-center gap-0.5">
            <div className="text-[13px] font-bold leading-[130%] text-black">{designer.name}</div>
            <div className="text-[11px] font-normal leading-[130%] text-gray-700">
              {designer.role}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
